module.exports = __webpack_public_path__ + "static/media/play.a9759291.svg";